export const ROW_COUNT = 3
export const COLUMN_COLORS = ["#91E595", "#C8CDD0", "#E36256", "#B861DC", "#5C7CDA"]
export const SEPARATORS = [114 / 720, 241 / 720, 72 / 720, 40 / 720]
